const skillsData = [
  {
    title: "Development & Programming",
    icon: "💻",
    groups: [
      {
        subtitle: "Frontend Languages & Frameworks",
        skills: ["C#", "JavaScript", "TypeScript", "HTML", "CSS", "React", "Oracle Jet"]
      },
      {
        subtitle: "Backend Frameworks & Databases",
        skills: ["Java", "C++", "python", "Django", "MySQL", "SpringBoot", "gradle"]
      },
      {
        subtitle: "XR & Game Development",
        skills: ["Unity", "MRTK Toolkit", "StereoKit", "HLSL"]
      }
    ]
  },
  {
    title: "Testing & Automation",
    icon: "🧪",
    groups: [
      {
        subtitle: "Testing Tools",
        skills: ["QUnit", "Selenium", "PowerMockito", "Karma", "Mocha"]
      }
    ]
  },
  {
    title: "Prototyping & Design",
    icon: "🎨",
    groups: [
      {
        subtitle: "Design Platforms",
        skills: ["Figma", "InVision", "Concepts", "Procreate"]
      }
    ]
  },
  {
    title: "Version Control",
    icon: "🔄",
    groups: [
      {
        subtitle: "Tools",
        skills: ["Git"]
      }
    ]
  },
  {
    title: "Agile & Collaboration",
    icon: "📋",
    groups: [
      {
        subtitle: "Methodologies & Platforms",
        skills: ["Agile", "JIRA", "Microsoft Boards", "Confluence", "Asana", "Trello", "Notion"]
      }
    ]
  },
  {
    title: "Devices & Platforms",
    icon: "📱",
    groups: [
      {
        subtitle: "Hardware Experience",
        skills: ["Lenovo A3", "SKU4", "Motorola Edge+", "Lenovo VRX", "Anorak SKU2", "Meta Quest"]
      }
    ]
  },
  {
    title: "Exploring & Learning",
    icon: "🚀",
    groups: [
      {
        subtitle: "Currently Expanding Backend Skills on:",
        skills: ["C++" , "Python", "Django", "MySQL", "SpringBoot", "gradle"]
      },
      {
        subtitle: "Currently Working Towards Specializations:",
        skills: ["Meta Back-End Developer", "Spring Boot REST API with Java & Gradle"]
      }
    ]
  },
  {
    title: "Licenses & certifications",
    icon: "🧠",
    groups: [
      {
        subtitle: "My Specializations",
        skills: ["Programming in C++" , "Software Design and Architecture Specialization", "Google Project Management"]
      }
    ]
  }
];

export default skillsData;